// import React, { useState } from "react";
import React from "react";
import deleteIcon from "../../../../assets/images/button/deleteIcon.svg";
import deleteIconDark from "../../../../assets/images/button/deleteIconDark.svg";
import folderIcon from "../../../../assets/images/fileImage/folderIcon.svg";
import commonFileIcon from "../../../../assets/images/homepage/ySafe/commonFile.svg";
import pdf from "../../../../assets/images/fileImage/pdf.svg";
import xls from "../../../../assets/images/fileImage/xls.svg";
import docs from "../../../../assets/images/fileImage/docs.svg";
import jpg from "../../../../assets/images/fileImage/jpg.svg";
import zip from "../../../../assets/images/homepage/ySafe/zip.svg";
import useTheme from "hooks/observer";
// import Modal from "components/Models/index";
// import addIcon from "assets/images/fileImage/addIcon.svg";
// import Input from "components/Input/index";
// import Button from "components/Button/index";
// import RenameFile from "components/RenameFile/index";
import "./SpaceTypesCard.scss";

export default function SpaceTypesCard({ selectedCategory, spaceObjs, selectedSpaceType, onSelectSpaceType, onAddSpaceType, onSetSpaceTypeEnabled, onDeleteSpaceType }) {
  // console.log("space types in space types card ",spaceObjs);
  //  TODO:assume spaceTypes,remove later
  const spaceTypes = (spaceObjs || []).map(obj => ({
    name: obj.name,
    uuid: obj.uuid,
    isFolder: obj.isFolder || false,
    enabled: true  // Setting default enabled state to true for all items
  }));
  const theme = useTheme();

  // Function to get file icon based on extension
  const getFileIcon = (fileName, isFolder) => {
    if (isFolder) {
      return folderIcon;
    }
    const extension = fileName?.split(".").pop()?.toLowerCase();
    switch (extension) {
      case "xls":
      case "xlsx":
      case "csv":
        return xls;
      case "pdf":
        return pdf;
      case "doc":
      case "docx":
        return docs;
      case "jpg":
      case "png":
      case "jpeg":
      case "svg":
        return jpg;
      case "zip":
        return zip;
      default:
        return commonFileIcon;
    }
  };
  // const [adding, setAdding] = useState(false);
  // const [newName, setNewName] = useState("");
  // const [showModal, setShowModal] = useState(false);
  // const [itemName, setItemName] = useState("");
  // const [showCreateModal, setShowCreateModal] = useState(false);


  // Theme-aware delete icon
  const getDeleteIcon = () => {
    return theme === "dark" ? deleteIconDark : deleteIcon;
  };

  const getFoldersTitle = () => {
    const name = (selectedCategory || "").trim();
    if (!name) return "Folders";
    return `Folders in ${name}`;
  };

  // const submitNew = () => {
  //   if (!onAddSpaceType) return;
  //   const trimmed = (newName || "").trim();
  //   if (!trimmed) {
  //     alert("Space type name cannot be empty.");
  //     return;
  //   }
  //   if (spaceTypes.some(type => type.name.toLowerCase() === trimmed.toLowerCase())) {
  //     alert("Space type with this name already exists.");
  //     return;
  //   }
  //   const ok = onAddSpaceType(trimmed);
  //   if (ok) {
  //     setNewName("");
  //     setAdding(false);
  //   }
  // };

  // const handleAddItem = () => {
  //   if (!itemName.trim()) {
  //     alert("Please enter a name for the item.");
  //     return;
  //   }

  //   // Check if item already exists
  //   if (spaceTypes.some(type => type.name.toLowerCase() === itemName.trim().toLowerCase())) {
  //     alert("An item with this name already exists.");
  //     return;
  //   }

  //   // Add the new item
  //   const ok = onAddSpaceType(itemName.trim());
  //   if (ok) {
  //     setItemName("");
  //     setShowModal(false);
  //   }
  // };

  // const handleCreateFolder = () => {
  //   if (!itemName.trim()) {
  //     alert("Please enter a folder name.");
  //     return;
  //   }

  //   // Check if folder already exists
  //   if (spaceTypes.some(type => type.name.toLowerCase() === itemName.trim().toLowerCase())) {
  //     alert("A folder with this name already exists.");
  //     return;
  //   }

  //   // Add the new folder
  //   const ok = onAddSpaceType(itemName.trim());
  //   if (ok) {
  //     setItemName("");
  //     setShowCreateModal(false);
  //   }
  // };

  // const handleCancel = () => {
  //   setShowModal(false);
  //   setShowCreateModal(false);
  //   setItemName("");
  // };

  return (
    <>
      <div className="Card">
        <div className="CardHeader">
          <h3>{getFoldersTitle()}</h3>
          {/* {!adding ? (
            <button className="PrimarySm" onClick={() => setShowModal(true)}>Add</button>
          ) : (
            <div className="InlineAdd">
              <input
                autoFocus
                value={newName}
                placeholder=""
                onChange={(e) => setNewName(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") submitNew();
                  if (e.key === "Escape") { setAdding(false); setNewName(""); }
                }}
              />
              <button onClick={submitNew}>Add</button>
              <button onClick={() => { setAdding(false); setNewName(""); }}>Cancel</button>
            </div>
          )} */}
        </div>
        <div className="CardBody">
          <ul className="List">
            {spaceTypes.length > 0 ? (
              spaceTypes.map(({ name, enabled, isFolder, uuid }) => (
                <li
                  key={uuid || name}
                  style={{
                    background: name === selectedSpaceType ? "var(--fill-brand-light)" : undefined,
                    fontWeight: name === selectedSpaceType ? 600 : 400,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "8px",
                    padding: "10px 12px",
                    borderRadius: "6px",
                    marginBottom: "4px",
                    transition: "background-color 0.2s ease"
                  }}
                >
                  <span
                    style={{
                      cursor: enabled ? "pointer" : "not-allowed",
                      flex: 1,
                      minWidth: 0,
                      opacity: enabled ? 1 : 0.5,
                      pointerEvents: enabled ? "auto" : "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px"
                    }}
                    onClick={() => enabled && onSelectSpaceType && onSelectSpaceType(name)}
                  >
                    <img
                      src={getFileIcon(name, isFolder)}
                      alt={isFolder ? "Folder" : "File"}
                      style={{
                        width: "16px",
                        height: "16px",
                        flexShrink: 0
                      }}
                    />
                    <span
                      className="SpaceTypeName"
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        minWidth: 0
                      }}
                      title={name}
                    >
                      {name}
                    </span>
                  </span>

                  <img
                    src={getDeleteIcon()}
                    alt="Delete"
                    style={{
                      width: "16px",
                      height: "16px",
                      cursor: "pointer",
                      opacity: 0.7,
                      transition: "opacity 0.2s",
                      flexShrink: 0
                    }}
                    onMouseEnter={(e) => e.target.style.opacity = "1"}
                    onMouseLeave={(e) => e.target.style.opacity = "0.7"}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (onDeleteSpaceType && uuid) {
                        onDeleteSpaceType(uuid);
                      }
                    }}
                  />
                </li>
              ))
            ) : (
              <li style={{
                padding: "20px 12px",
                opacity: 0.7,
                fontStyle: "italic",
                textAlign: "center",
                color: "var(--text-grey-neutral)"
              }}>
                No space types available. Click &quot;Add&quot; to create one.
              </li>
            )}
          </ul>
        </div>
      </div>

      {/* Add Files/Folders Modal */}
      {/* {showModal && (  */}
      {/* TODO:LATER REMOVE FALSE AND UNCOMMENT ABOVE LINE(SHOW MODAL &&  ) */}
      {false && (
        <div></div>
        // <Modal
        //   // heading="Add Files & Folders"
        //   handleCancel={handleCancel}
        //   showFooter={false}
        //   showCross={true}
        // >
        //   <div className="moveFileContainer">
        //     <div className="folderFile">
        //       <div className="selectedFileName">
        //         <p>All Files</p>
        //       </div>
        //       <div className="inputBox">
        //         <Input
        //           placeholder="Search"
        //           searchIconBool={true}
        //           value={itemName}
        //           onChange={(e) => setItemName(e.target.value)}
        //           onKeyDown={(e) => {
        //             if (e.key === "Enter") handleAddItem();
        //             if (e.key === "Escape") handleCancel();
        //           }}
        //           left="20px"
        //         />
        //       </div>
        //     </div>
        //     <div className="folderNamesContainer">
        //       {/* Empty space for user-created files/folders */}
        //     </div>
        //     <div className="MoveFileFooter">
        //       {/* <div className="footer" onClick={() => setShowCreateModal(true)} style={{ cursor: "pointer" }}>
        //         <img src={addIcon} alt="Add Folder" />
        //         <p>Create New Folder / File</p>
        //       </div> */}
        //       <Button
        //         title="Select"
        //         type="violet"
        //         width="32%"
        //         onClick={handleAddItem}
        //         disabled={!itemName.trim()}
        //       />
        //     </div>
        //   </div>
        // </Modal>
      )}

      {/* Create Folder Modal */}
      {/* {showCreateModal && (
        <RenameFile
          submitBtnText="Create"
          label="Create Folder"
          placeholder="Folder name"
          value={itemName}
          onChange={(e) => {
            const newValue = e.target.value.replace(/[^a-zA-Z0-9 _\-()]/g, "");
            setItemName(newValue);
          }}
          handleSave={handleCreateFolder}
          handleCancel={() => setShowCreateModal(false)}
          heading="Create Folder"
          wrapWidth="100%"
          disabled={itemName.length === 0}
          mockClass={"ysafe"}
        />
      )} */}
    </>
  );
}
